import React, { PureComponent } from 'react';
import { array, func, object, objectOf, string } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImageBanner from 'yoda-core-components/lib/components/Banner/Banner';
import { checkUrlExtension, replaceSubdomain } from 'yoda-core-components/lib/helpers/Utils/Utils';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { isPDPPage } from '../../../helpers/Utils/pageType';
import RevieveModalLazy from '../../../components/Revieve/RevieveModalLazy';
import analyticsActions from '../../../actions/AnalyticsAction';
import actions from '../../../actions/AddToCartAction';
import plccHelper from '../../../helpers/Utils/plccHelper';

class IrisImageBanner extends PureComponent {
    static propTypes = {
        actions: objectOf(func),
        automationId: string,
        channels: array,
        preferences: object,
        dataPlccName: string,
        dataPlccId: string,
        plccAnalyticsTagName: string,
        requestUrl: string,
    };

    static defaultProps = {
        actions: {},
        automationId: 'image-banner',
        channels: [],
        preferences: {},
        dataPlccName: '',
        dataPlccId: '',
        plccAnalyticsTagName: '',
        requestUrl: '',
    };

    constructor(props) {
        super(props);
        this.state = {
            analyticsPayload: [],
            bannerData: this.props.channels[0],
            imageError: false,
        };
    }

    componentDidMount() {
        const { plccAnalyticsTagName, requestUrl } = this.props;
        const { bannerData: { analyticsTag = '' } = {} } = this.state;

        /* istanbul ignore next */
        if (analyticsTag.toUpperCase().includes(plccAnalyticsTagName)) {
            const elementDOMObj = document.getElementById('plcc-banner-element');
            if (elementDOMObj) {
                elementDOMObj.addEventListener('click', this.applyPlccAnalytics);
                const payloadParams = {
                    plccBanner: isPDPPage(requestUrl) ? 'static_PDP_apply' : 'static_home_apply',
                };
                this.props.actions.plccViewsAnalytics(payloadParams);
            }
        }
    }

    componentDidUpdate() {
        plccHelper(this.props.actions.plccApplyAnalytics, {
            plccBanner: 'static_home_apply',
        });
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        /* istanbul ignore next */
        if (nextProps?.channels[0]?.linkText !== prevState?.bannerData?.linkText) {
            return {
                bannerData: nextProps?.channels[0],
            };
        }
        return null;
    }

    /* istanbul ignore next */
    componentWillUnmount() {
        const { plccAnalyticsTagName } = this.props;
        const { bannerData: { analyticsTag = '' } = {} } = this.state;
        /* istanbul ignore next */
        if (analyticsTag.toUpperCase().includes(plccAnalyticsTagName)) {
            const elementDOMObj = document.getElementById('plcc-banner-element');
            if (elementDOMObj) {
                elementDOMObj.removeEventListener('click', this.applyPlccAnalytics);
            }
        }
    }

    isPlccEnableLink = () => {
        const { plccAnalyticsTagName } = this.props;
        const { bannerData: { analyticsTag = '' } = {} } = this.state;
        return analyticsTag.toUpperCase().includes(plccAnalyticsTagName);
    };

    /* istanbul ignore next */
    applyPlccAnalytics = () => {
        const { requestUrl } = this.props;
        const payloadParams = {
            plccBanner: isPDPPage(requestUrl) ? 'static_PDP_apply' : 'static_home_apply',
        };

        this.props.actions.plccApplyAnalytics(payloadParams);
    };

    /* istanbul ignore next */
    render() {
        const { automationId, preferences, dataPlccName, dataPlccId } = this.props;
        const { bannerData } = this.state;
        const {
            altText = '',
            analyticsTag = '',
            image: { dimensions: imageDimensions = '' } = {},
            link: { url: linkUrl = '' } = {},
            linkText = '',
            openInNewTab = false,
        } = bannerData;
        let { image: { url: imageurl = '' } = {} } = bannerData;
        const imageExt = checkUrlExtension(imageurl);
        imageurl = replaceSubdomain(imageurl, preferences);

        const renderImageBanner = () => {
            return (
                <ImageBanner
                    altText={altText}
                    analyticsTag={analyticsTag}
                    ariaLabel={linkText}
                    automationId={automationId}
                    bannerImageClass={dt(['!h-25'])}
                    bannerImageUrl={imageurl}
                    height={imageDimensions ? imageDimensions.height : ''}
                    href={linkUrl}
                    onImageError={() => this.setState({ imageError: true })}
                    target={openInNewTab ? '_blank' : ''}
                    width={imageDimensions ? imageDimensions.width : ''}
                    plccName={dataPlccName}
                    plccId={dataPlccId}
                />
            );
        };

        const componentRendered = () => {
            return (
                <div>
                    {this.isPlccEnableLink() ? (
                        <div id="plcc-banner-element">{renderImageBanner()}</div>
                    ) : (
                        renderImageBanner()
                    )}
                </div>
            );
        };

        return imageExt === 'mp4' ? (
            <video playsInline autoPlay muted loop width="100%" height="100%">
                <source src={imageurl} type="video/mp4" />
            </video>
        ) : (
            <>
                <RevieveModalLazy
                    data={bannerData.analyticsTag}
                    componentToBeRendered={componentRendered()}
                />
            </>
        );
    }
}

export const mapStateToProps = ({
    context: { requestUrl = '', preferences: { plccAnalyticsTagName = 'PLCC' } = {} } = {},
}) => ({
    plccAnalyticsTagName,
    requestUrl,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            ...actions,
            ...analyticsActions,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(IrisImageBanner);
